import script from "./PaymentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsView.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentsView.vue?vue&type=style&index=0&id=3ff4c5c2&lang=css"

const __exports__ = script;

export default __exports__